import { makeStyles } from 'tss-react/mui';


export const useStyles = makeStyles()((theme) => ({
  content: {
    justifyContent: 'flex-end',
    padding: theme.spacing(2),

    '&:last-child': {
      paddingBottom: theme.spacing(2),
    }
  },
  info: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  rightBlock: {
    paddingLeft: theme.spacing(2),
  },
  accountImage: {
    width: '88px',
    height: '88px',
  },
  fullNameText: {
    fontWeight: 600,
    fontSize: '18px',
  },
  typeText: {
    marginBottom: '4px',
  },
  lastSeenText: {
  },
}));
